'use strict';

import $ from 'jquery';
import ListingFilter from '../../molecules/listing-filter/listing-filter';

export default class SearchResults {
  constructor() {
    let $search = $('.search-results');

    let searchResults = new ListingFilter($search);

  }
}
